import {useEffect, useState}  from "react";
import axios from "axios";

import "./link.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile } from "@fortawesome/free-solid-svg-icons";

export default function Link(props){
    const [title, setFileTitle] = useState(props.fileID);


    useEffect(() => {
        axios.get(`https://api-als2.nutramax.com/files/${props.fileID}`)
        .then(response => setFileTitle(response.data.data.title))
    }, [title])
    
    return (
        <a style={{display: "block" }}  href={`https://api-als2.nutramax.com/assets/${props.fileID}?download`}>  
                      <FontAwesomeIcon icon={faFile}/>  {title}
        </a>
    )
}